import { useLocale } from "Infrastructure/Hooks/useLocale";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Box, Typography, useTheme } from "@mui/material";

type XPCellProps = {
  value: number;
};

const FIRST_GRADIENT_COLOR = "#c9b3d7";
const SECOND_GRADIENT_COLOR = "#7148aa";

export const XPCell = ({ value }: XPCellProps) => {
  const locale = useLocale();
  const { customFontWeight } = useTheme();
  const formattedValue = value.toLocaleString(locale);
  const { t } = useResource();

  return (
    <Box textAlign="right">
      <Typography
        variant="body2"
        fontWeight={customFontWeight.bold}
        sx={{
          background: `radial-gradient(farthest-corner at 40px 50px, ${FIRST_GRADIENT_COLOR}, ${SECOND_GRADIENT_COLOR})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {t(Resources.Common.XP, { amount: formattedValue })}
      </Typography>
    </Box>
  );
};
